import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { rolesApi as n } from "@maat/api-main";
//#region src/workspaces/useWorkspaceRolesQuery.ts
var r = () => t({
	queryKey: e.roles(),
	queryFn: n.getRoles
});
//#endregion
export { r as useWorkspaceRolesQuery };
